// extracted by mini-css-extract-plugin
export var actions = "_jg-d";
export var benefitCard = "_jg-a";
export var benefitIcon = "_jg-b";
export var benefitLabel = "_jg-c";
export var benefits = "_jg-9";
export var bodyText = "_jg-8";
export var closeButton = "_jg-2";
export var content = "_jg-3";
export var eyebrow = "_jg-4";
export var heading = "_jg-5";
export var image = "_jg-f";
export var imagePanel = "_jg-e";
export var modal = "_jg-0";
export var shell = "_jg-1";
export var title = "_jg-6";
export var titleOffer = "_jg-7";